import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import PrivacyPolicy from './PrivacyPolicy';

const PrivacyAcceptance = ({ 
  checked = false, 
  onChange, 
  error = false,
  required = true,
  className = '' 
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleCheckboxChange = (e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const baseClassName = `PrivacyAcceptance ${error ? 'PrivacyAcceptance--error' : ''} ${className}`.trim();

  return (
    <>
      <div className={baseClassName}>
        <label className="PrivacyAcceptance__checkbox">
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxChange}
            required={required}
          />
          <span className="PrivacyAcceptance__checkmark" />
        </label>
        
        <span className="PrivacyAcceptance__text">
          {t('privacyPolicy.acceptText')}{' '}
          <a 
            href="#privacy-policy" 
            className="PrivacyAcceptance__link"
            onClick={handleLinkClick}
          >
            {t('privacyPolicy.linkText')}
          </a>
          {required && ' *'}
        </span>
      </div>
      
      {showModal && (
        <PrivacyPolicy 
          isModal={true} 
          onClose={handleCloseModal} 
        />
      )}
    </>
  );
};

PrivacyAcceptance.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string
};

export default PrivacyAcceptance;